export default "__VITE_ASSET__893fe3e1__"